import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router';
import Talk from './talk/Talk'
import { IonPage } from '@ionic/react'
import { useSelector } from 'react-redux';
import { trackPage } from '../helpers/tracker_actions';
import history from '../helpers/history';

interface ParamTypes {
  meetingKey: string
  who: string
  name: string
  externalId?: string
}

const TalkPage = () => {
  const talkOpen = useSelector((state: any) => state.talkOpen.isOpen)
  const { meetingKey, who, name, externalId } = useParams<ParamTypes>()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    trackPage('TALK_PAGE')
    // console.log('talkpage:', talkOpen)
  }, [])

  useEffect(() => {
    setIsOpen(talkOpen)
  }, [talkOpen])

  return (
    <IonPage className="cheap_desktop">
      <Talk 
        isOpen={isOpen} 
        setIsOpen={setIsOpen}
        meetingKey={meetingKey}
        name={name}
        externalId={externalId}
        who={who}
        history={history}
        walkId={history.location.state}/>
    </IonPage>
  )
}

export default TalkPage
